import { getEnv } from '@move-web-essentials-utils/env';

const API_VERSION_ENV = 'move_consumer_api_version';

const getApiVersion = () => getEnv(API_VERSION_ENV);

export default getApiVersion;
